import { Container, Row, Col, Image } from "react-bootstrap";
import { Bounce, Slide } from "react-reveal";
import { StyledSection, StyledCover } from "./suppliers-screen-styles";
import SupplierImg1 from "../../assets/images/supp1.png";
import SupplierImg2 from "../../assets/images/supp2.png";
import SupplierImg3 from "../../assets/images/supp3.png";

const SuppliersScreen = () => {
  return (
    <>
      <StyledSection>
        <div className="header-text">
          <Bounce left>
            <h1 className="text-center">
              Join the number 1 platform for medical suppliers
            </h1>
          </Bounce>
        </div>
      </StyledSection>
      <StyledCover>
        <Bounce right>
          <h1>We help connect you to your customers</h1>
        </Bounce>
      </StyledCover>
      <StyledSection>
        <Container>
          <Row className="gx-5 gy-5">
            <Col xs={12} sm={12} md={4}>
              <Slide left>
                <div className="text-center">
                  <Image
                    src={SupplierImg1}
                    alt="image1"
                    className="supp-images"
                    fluid
                  />
                  <h2>Simplify your current logistics process</h2>
                  <p>
                    By listing and selling supplies from your online account
                  </p>
                </div>
              </Slide>
            </Col>

            <Col xs={12} sm={12} md={4}>
              <Slide bottom>
                <div className="text-center">
                  <Image
                    src={SupplierImg2}
                    alt="image1"
                    className="supp-images"
                    fluid
                  />
                  <h2>Recieve online orders and payments</h2>
                  <p>
                    Our platform guarrantess safety and securety of all
                    transactions
                  </p>
                </div>
              </Slide>
            </Col>

            <Col xs={12} sm={12} md={4}>
              <Slide right>
                <div className="text-center">
                  <Image
                    src={SupplierImg3}
                    alt="image1"
                    className="supp-images"
                    fluid
                  />
                  <h2 className="hh2">Increase your margins</h2>
                  <p>By having access to all the users on our platfrom </p>
                </div>
              </Slide>
            </Col>
          </Row>
        </Container>
      </StyledSection>
    </>
  );
};

export default SuppliersScreen;
